import { useMemo } from 'react';
import { AUTOMATIC_RECURRING_PAYMENT_TYPES } from '../constants';

const useIsAutomaticRecurringPayment = (paymentFrequency) => useMemo(
  () => paymentFrequency
      && Object.values(AUTOMATIC_RECURRING_PAYMENT_TYPES).includes(paymentFrequency.value),
  [paymentFrequency],
);

export default useIsAutomaticRecurringPayment;
